import { Tooltip } from "@material-ui/core";
import { DataTable, TaskLink } from "../../components";
import { dataTableStyles } from "../styles";

export default function TaskList({ selectedTask, tasks, workflowId }) {
  const taskDetailFields = [
    { name: "seq", label: "Seq", grow: 0.2 },
    {
      name: "taskId",
      label: "Task ID",
      wrap: false,
      renderer: (taskId) => (
        <TaskLink workflowId={workflowId} taskId={taskId} />
      ),
      grow: 2,
    },
    {
      name: "workflowTask.name",
      id: "taskName",
      label: "Task Name",
      wrap: false,
      renderer: (val) => (
        <Tooltip title={val}>
          <div>{val}</div>
        </Tooltip>
      ),
    },
    {
      name: "referenceTaskName",
      label: "Ref",
      wrap: false,
      renderer: (val) => (
        <Tooltip title={val}>
          <div>{val}</div>
        </Tooltip>
      ),
    },
    {
      name: "workflowTask.type",
      id: "taskType",
      label: "Type",
      grow: 0.5,
      wrap: false,
    },
    {
      name: "scheduledTime",
      label: "Scheduled Time",
      type: "date-ms",
      wrap: false,
    },
    { name: "startTime", label: "Start Time", type: "date-ms", wrap: false },
    { name: "endTime", label: "End Time", type: "date-ms", wrap: false },
    { name: "status", label: "Status", grow: 0.8, wrap: false },
    { name: "updateTime", label: "Update Time", type: "date-ms", wrap: false },
    {
      name: "callbackAfterSeconds",
      label: "Callback After Seconds",
      wrap: false,
    },
    { name: "pollCount", label: "Poll Count", grow: 0.5, wrap: false },
  ];

  return (
   
      <DataTable
        style={{ minHeight: 400 }}
        data={tasks}
        columns={taskDetailFields}
        defaultShowColumns={[
          "seq",
          "taskId",
          "taskName",
          "referenceTaskName",
          "taskType",
          "startTime",
          "endTime",
          "status",
        ]}
        localStorageKey="taskListTable"
        customStyles={dataTableStyles}
        fixedHeader
        fixedHeaderScrollHeight="calc(100vh - 240px)"
      />
  );
}
